import { jsx as _jsx } from "react/jsx-runtime";
export const SvgLine = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm3 14.4 4-4.3 8.2 7.7L21 6.2' }) }));
//# sourceMappingURL=line.js.map